var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLemonDrops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63027 9.82493C7.15591 9.61438 8.57998 13.9943 7.63611 18.2037C7.63565 19.6671 3.30765 21.113 2.80191 17.145C2.67146 16.1215 5.97321 10.0881 6.63027 9.82493Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0807 8.5075C10.4868 8.12256 13.3909 11.6271 14.0576 15.8379C14.5904 17.1823 11.1415 20.0875 9.23112 16.6267C8.73835 15.7341 9.57303 8.98868 10.0807 8.5075Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55885 2.47568C9.72216 2.3209 10.8899 3.73007 11.158 5.42319C11.3722 5.96379 9.98539 7.13195 9.21724 5.74039C9.0191 5.38145 9.35472 2.66916 9.55885 2.47568Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0981 3.59532C6.93683 3.38051 5.28083 4.80567 4.6269 6.74482C4.26672 7.33826 5.66544 8.99032 6.84766 7.50604C7.1526 7.12318 7.29969 3.86384 7.0981 3.59532Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonDrops);
export default __webpack_public_path__ + "static/media/lemon-drops.77c29ed4f94d070a9fb823351669a8d9.svg";
export { ForwardRef as ReactComponent };